import slide1 from './Images/Slide1.JPG';
import slide2 from './Images/Slide2.JPG';
import slide3 from './Images/Slide3.JPG';
import slide4 from './Images/Slide4.JPG';
import slide5 from './Images/Slide5.JPG';

const presentation = {slide1,
    slide2,
    slide3,
    slide4,
    slide5};

export default presentation;
